module.exports = __webpack_public_path__ + "static/media/EditorsPick1.68b92893.png";